(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["template-page-newsletter-landing"]) return;
  try {
    
  var phoneInputField = document.querySelector('#phone_number');
  var phoneInput = window.intlTelInput(phoneInputField, {
    preferredCountries: ['au'],
    utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js',
  });

  } catch(e) { console.error(e); }
})();
})();
